<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="名称">
                  <el-input  v-model="queryForm.colorName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashProductColorList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashProductColor"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashProductColor(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashProductColor(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashProductColorList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washProductColorList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="colorName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="colorCode"
        label="颜色码"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shortcut"
        label="快捷键"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashProductColor(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashProductColor(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashProductColor(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washProductColorStates[washProductColorState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washProductColor"
          ref="washProductColorForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="colorName"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="washProductColor.colorName"
              :disabled="washProductColorState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="颜色码"
            prop="colorCode"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washProductColor.colorCode"-->
<!--              :disabled="washProductColorState == 'check'"-->
<!--            ></el-input>-->
              <div style="display: flex;width: 200px;align-items: center;">
                  <el-input v-model="washProductColor.colorCode" size="small" style="flex: 1;" :disabled="washProductColorState == 'check'"></el-input>
                  <el-color-picker v-model="washProductColor.colorCode" size="medium" style="margin-left: 2px;" :disabled="washProductColorState == 'check'"></el-color-picker>
              </div>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="washProductColor.sort"
              :disabled="washProductColorState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="快捷键"
            prop="shortcut"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="washProductColor.shortcut"
              :disabled="washProductColorState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washProductColorState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashProductColorList();
                    this.getWashProductColorList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashProductColorList();
                    this.getWashProductColorList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     colorName: '', //名称
                     colorCode: '', //颜色码
                     sort: '', //排序
                     shortcut: '', //快捷键
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washProductColorState: 'add',
                washProductColorStates: {
                    add: '新建颜色设置',
                    check: '查看颜色设置',
                    edit: '修改颜色设置'
                },

                multipleSelection: [],
                washProductColorList: [],
                washProductColor: {
                    id: '', //ID
                    colorName: '', //名称
                    colorCode: '', //颜色码
                    sort: '', //排序
                    shortcut: '', //快捷键
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    colorName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    colorCode: [{ required: true, message: '颜色码不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashProductColorList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashProductColorList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washProductColorList = [];
            },
            resetDialog() {
                this.washProductColorState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      colorName: '', //名称
                      colorCode: '', //颜色码
                      sort: '', //排序
                      shortcut: '', //快捷键
                };
                this.getWashProductColorList();
            },
            closeDialog() {
                this.showDialog = false
                this.washProductColor = {
                      id: '', //ID
                      colorName: '', //名称
                      colorCode: '', //颜色码
                      sort: '', //排序
                      shortcut: '', //快捷键
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.washProductColorState == 'add') {
                    this.$refs.washProductColorForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/productcolor/add`,{ ...this.washProductColor }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashProductColorList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washProductColorState == 'edit') {
                    this.$refs.washProductColorForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/productcolor/edit`,{ ...this.washProductColor }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashProductColorList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashProductColor() {
                this.showDialog = true;
                this.washProductColorState = 'add';
            },
            checkWashProductColor(washProductColorId) {
                console.log(washProductColorId);
                this.currentWashProductColorId = washProductColorId;

                this.getWashProductColorById();
                this.showDialog = true;
                this.washProductColorState = 'check';
            },
            editWashProductColor(washProductColorId) {
                console.log('washProductColor', washProductColorId);
                if (washProductColorId) {
                    this.currentWashProductColorId = washProductColorId;
                    this.getWashProductColorById();
                } else {
                    this.washProductColor = { ...this.washProductColor, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washProductColorState = 'edit';
            },
            deleteWashProductColor(washProductColorId) {
                let ids = '';
                if (washProductColorId) {
                    ids = washProductColorId;
                } else {
                    ids = this.multipleSelection.map((washProductColor) => washProductColor.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/productcolor/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashProductColorList();
                                this.getWashProductColorList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashProductColorList() {
                this.resetWashProductColorList();
                this.getWashProductColorList();
            },
            getWashProductColorList(query = {}) {
                this.loading = true;
                get(`/wash/productcolor/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washProductColorList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashProductColorById() {
                get(`/wash/productcolor/get`,{ id: this.currentWashProductColorId }).then((res) =>{
                    if(res.success){
                      this.washProductColor = { ...this.washProductColor, ...res.washProductColor };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashProductColorList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/productcolor/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/productcolor/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/productcolor/importData`,formData);
              this.refreshWashProductColorList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashProductColorList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashProductColorList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>